import $ from 'jquery';



/* Parity
********************************************/

if ($('.js-parity-toggle').length) {
	$('.js-parity-toggle').on('click', function (e) {
		e.preventDefault();
		var $this = $(this);
		var $parent = $this.closest('.c-parity');

		$this.toggleClass('is-active');
		$parent.find('.c-parity__content').toggleClass('is-selected');
	});
}
